<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import GgiLogo from '@/components/GgiLogo.vue'

/**
 * Shown from the first paint until the session is resolved (MSAL redirect
 * handling and `/me`), so the page is never blank while the app starts. It is
 * mounted on its own, before the router and the main app exist.
 */
const { t } = useI18n()
</script>

<template>
  <div class="flex min-h-screen flex-col items-center justify-center gap-6 bg-surface-raised p-6" role="status" aria-live="polite">
    <GgiLogo class="h-32 w-auto select-none" />
    <div class="flex items-center gap-3 text-ink-secondary">
      <span class="splash-spinner" aria-hidden="true" />
      <span class="body-md">{{ t('common.loading') }}</span>
    </div>
  </div>
</template>

<style scoped>
.splash-spinner {
  width: 1.125rem;
  height: 1.125rem;
  border-radius: 9999px;
  border: 2px solid currentColor;
  border-right-color: transparent;
  opacity: 0.55;
  animation: splash-spin 0.9s linear infinite;
}

@keyframes splash-spin {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .splash-spinner {
    animation-duration: 2.4s;
  }
}
</style>
